var map = {
	"./26-dic-wirebit-celular.svg": 412,
	"./Bullet-check.svg": 56,
	"./Bullet.svg": 55,
	"./Copia de info.svg": 300,
	"./account_circle.svg": 1296,
	"./add_card.svg": 303,
	"./addresses_restantes.svg": 293,
	"./app-wbd.svg": 413,
	"./arrow-alt-circle-down-regular.svg": 1297,
	"./arrow-down.svg": 207,
	"./arrow-left.svg": 43,
	"./available-apple-store.svg": 1298,
	"./back-arrow.svg": 95,
	"./back.svg": 1299,
	"./bloquear.svg": 86,
	"./calendar.svg": 1300,
	"./camera.svg": 1301,
	"./cancelada.svg": 304,
	"./cancelar-tarjeta.svg": 305,
	"./card-placeholder-white.svg": 171,
	"./celular-14dic.svg": 1302,
	"./celular-15-dic.svg": 1303,
	"./celular.svg": 1304,
	"./check-correct-blue.svg": 1305,
	"./check-correct.svg": 33,
	"./check-mark-button.svg": 1306,
	"./check-solid.svg": 1307,
	"./check.svg": 31,
	"./compra.svg": 172,
	"./config.svg": 1308,
	"./configurar.svg": 306,
	"./correct.svg": 1309,
	"./custody.svg": 1310,
	"./depositar-azul.svg": 307,
	"./depositar.svg": 308,
	"./deposito.svg": 173,
	"./desbloquear.svg": 96,
	"./detalle.svg": 309,
	"./download-icon.svg": 299,
	"./edit.svg": 161,
	"./estimated_balance.svg": 87,
	"./external-link.svg": 294,
	"./facebook.svg": 1311,
	"./flecha.svg": 106,
	"./forma-azul.svg": 414,
	"./forma-naranja.svg": 415,
	"./go_arrow.svg": 249,
	"./hidden.svg": 174,
	"./info.svg": 104,
	"./instagram.svg": 1312,
	"./kyc/Argentina.svg": 166,
	"./kyc/Bolivia.svg": 167,
	"./kyc/Colombia.svg": 168,
	"./kyc/Ecuador.svg": 169,
	"./kyc/Peru.svg": 170,
	"./kyc/f_id_back.svg": 298,
	"./kyc/f_id_front.svg": 163,
	"./kyc/f_id_selfie.svg": 164,
	"./kyc/f_passport.svg": 162,
	"./kyc/f_utility_bill.svg": 165,
	"./kyc/help_tools.svg": 45,
	"./kyc/other_files.svg": 49,
	"./kyc/persona_fisica.svg": 250,
	"./kyc/persona_moral.svg": 251,
	"./kyc/rfc_curp.svg": 107,
	"./landing/WirebitFaq/IconoPrueba.svg": 1313,
	"./landing/bars-solid.svg": 1314,
	"./language.svg": 374,
	"./linkedin.svg": 1315,
	"./liquidity.svg": 1316,
	"./logo_wirebit.svg": 416,
	"./logout_icon.svg": 376,
	"./lupa.svg": 1317,
	"./max.svg": 1318,
	"./meeting.svg": 1319,
	"./min.svg": 1320,
	"./monetizationG.svg": 1321,
	"./monetizationR.svg": 1322,
	"./movimientos.svg": 310,
	"./next.svg": 1323,
	"./no-commerce.svg": 1324,
	"./noTransaction.svg": 291,
	"./pdf-receipt.svg": 301,
	"./plans.svg": 385,
	"./price_check.svg": 1325,
	"./price_error.svg": 1326,
	"./qr-code.svg": 296,
	"./refresh.svg": 295,
	"./reposicion-tarjeta.svg": 311,
	"./retiro-azul.svg": 312,
	"./retiro.svg": 313,
	"./right-chevron.svg": 1327,
	"./salir.svg": 32,
	"./search-blue.svg": 160,
	"./search.svg": 59,
	"./security.svg": 1328,
	"./send-button.svg": 118,
	"./show.svg": 175,
	"./success_validation.svg": 1329,
	"./tarjeta-15dic.svg": 417,
	"./tarjeta-bloqueada.svg": 176,
	"./tarjeta.svg": 1330,
	"./tarjeta_agregada.svg": 314,
	"./tarjeta_no_valida.svg": 315,
	"./times-solid.svg": 1331,
	"./user_icon.svg": 375,
	"./wallets_restantes.svg": 158,
	"./warning.svg": 316,
	"./warningblue.svg": 297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1295;